import { ValidationListComponent } from "./validation-list";

export const containers = [ValidationListComponent];

export { ValidationListComponent };
